import React from "react";
import PopUp from "./Popup";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import HttpApiUtil from "../../../../ApiUtils/HttpApiUtil";
import ReactLoaderSpinner from "react-loader-spinner";
const ObjHttpApiUtil = new HttpApiUtil();

const convertLabel = {
  "233": "HDFC Bank Limited",
  "234": "ICICI Bank Limited",
  "237": "Kotak Mahindra Bank Limited",
  "239": "Axis Bank Limited",
};

const KeyFactStatementModal = ({
  handleClose,
  tenureId = "",
  interestRate = "",
  monthlyInstallemnt = "",
  bankData = {},
  loanAmount = 0,
  paymentMode = "4"
}) => {
  const [data, updateData] = useState({});
  const [isLoading, updateIsLoading] = useState(true);
  const [isError, updateIsError] = useState(true);

  const state = useSelector((state) => state);
  const customerData =
    state?.merchantPaymentDataFetchingReducer?.merchantPaymentData
      ?.customer_data?.shipping_data;
  useEffect(() => {
    ObjHttpApiUtil.keyFactStatement({
      Tenure: tenureId,
      IssuerID: bankData.issuer_id || 0,
      LoanAmount: loanAmount,
      TotalInterestCharge: interestRate,
      PaymentMode: paymentMode,
      EMIAmount: monthlyInstallemnt,
    })
      .then((res) => {
        const data = {};
        let keyfactStatement = res?.data?.keyfact_statement;
        Object.keys(keyfactStatement).forEach((item) => {
          if (keyfactStatement[item]) {
            data[item] = keyfactStatement[item];
          }
        });
        updateIsLoading(false);
        updateData(data);
        updateIsError("");
      })
      .catch((err) => {
        updateIsError("Unable to Load Key Fact statement Please Try Again!");
        console.log("error in keyFActStateent", err);
      });
  }, [bankData, interestRate, loanAmount, monthlyInstallemnt, tenureId]);
  var date = new Date(); // you can put any date you want in place of new Date()

  var options = { day: "numeric", month: "long", year: "numeric" };

  return (
    <PopUp popUpClassName="h-534" className="w-700 kfs-wrapper" onClose={handleClose}>
      <>
        <div class="modal-content" style={{ overfloWY: "auto" }}>
          {isLoading ? (
            <div className="ket-fact-loader-wrapper">
              {isError.length > 0 ? (
                <h1>{isError}</h1>
              ) : (
                <ReactLoaderSpinner
                  type="TailSpin"
                  color="var(--primary-theme-color)"
                  height={100}
                  width={100}
                  timeout={60000}
                />
              )}
            </div>
          ) : (
            <div class="modal-body clearfix key-fact-modal">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                <h2>
                  Key Fact Statement 
                </h2>
              </div>
              <div>
                <table>
                  <tr>
                    <th>Name of the Regulated entity</th>
                    <th>{convertLabel[bankData?.issuer_id || ""] || bankData?.issuer_name || ""}</th>
                  </tr>
                  <tr>
                    <th>Applicant Name</th>
                    <th>
                      {customerData?.first_name || ""}{" "}
                      {customerData?.last_name || ""}{" "}
                    </th>
                  </tr>
                  <tr>
                    <th>Date</th>
                    <th>{date.toLocaleDateString("en-US", options) || ""}</th>
                  </tr>
                </table>
                <hr className="divider" />
                <table>
                  <tr>
                    <th className="serial-no">Sr No.</th>
                    <th className="parameter-column">Parameter</th>
                    <th className="detalis-column">
                      Details (given for illustrative computation purposes only)
                    </th>
                  </tr>
                  <tr>
                    <td className="serial-no">(i)</td>
                    <td className="parameter-column">
                      {" "}
                      Loan amount (amount disbursed/to be disbursed to the
                      borrower) (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.LoanAmount ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(ii)</td>
                    <td className="parameter-column">
                      {" "}
                      Total interest charge during the entire tenor of the loan
                      (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.TotalInterestCharge ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(iii)</td>
                    <td className="parameter-column">
                      {" "}
                      Other up-front charges if any (break-up of each component
                      to be given below) (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.UpFrontCharges ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">a{")"}</td>
                    <td className="parameter-column">
                      {" "}
                      Processing fees, if any (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.ProcessingFees
                        ? `${data?.ProcessingFees} ${
                            bankData?.issuer_id == 234 ? " + GST" : ""
                          }`
                        : "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">b{")"}</td>
                    <td className="parameter-column">
                      {" "}
                      Insurance charges, if any (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.InsuranceCharges ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">c{")"}</td>
                    <td className="parameter-column">
                      {" "}
                      Others (if any) (in Rupees) (details to be provided)
                    </td>
                    <td className="detalis-column">
                      {data?.OtherCharges ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(iv)</td>
                    <td className="parameter-column">
                      Net disbursed amount ((i)-(iii)) (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.NetDisbursedAmount ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(v)</td>
                    <td className="parameter-column">
                      {" "}
                      Total amount to be paid by the borrower (sum of (i), (ii)
                      and (iii)) (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.TotalAmountPaid ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(vi)</td>
                    <td className="parameter-column">
                      {" "}
                      Annual Percentage Rate - Effective annualized interest
                      rate (in percentage) (computed on net disbursed amount
                      using IRR approach and reducing balance method)
                    </td>
                    <td className="detalis-column">
                      {data?.AnnualPercentageRate ?? "0%"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(vii)</td>
                    <td className="parameter-column">
                      {" "}
                      Tenor of the Loan (in months/days)
                    </td>
                    <td className="detalis-column">{data?.Tenure ?? "0"}</td>
                  </tr>
                  <tr>
                    <td className="serial-no">(viii)</td>
                    <td className="parameter-column">
                      {" "}
                      Repayment frequency by the borrower
                    </td>
                    <td className="detalis-column">
                      {data?.RepaymentFrequency ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(ix)</td>
                    <td className="parameter-column">
                      {" "}
                      Number of instalments of repayment
                    </td>
                    <td className="detalis-column">
                      {data?.NumberOfInstallment ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(x)</td>
                    <td className="parameter-column">
                      {" "}
                      Amount of each instalment of repayment (in Rupees)
                    </td>
                    <td className="detalis-column">
                      {data?.InstallmentAmount ?? "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no"></td>
                    <td className="parameter-column fontWght600">
                      {" "}
                      Details about Contingent Charges
                    </td>
                    <td className="detalis-column"></td>
                  </tr>
                  <tr>
                    <td className="serial-no">(xi)</td>
                    <td className="parameter-column">
                      Rate of annualized penal charges in case of delayed
                      payments (if any)
                    </td>
                    <td className="detalis-column">
                      {data.AnnualPenalCharges ? (
                        <div className="other-charges-penal">
                          {data?.AnnualPenalCharges?.split("||").length > 1
                            ? data?.AnnualPenalCharges?.split(" ||").map(
                                (item) => (
                                  <div className="d-flex jus-con-spc-btw">
                                    <p className="fontWght600">
                                      {item ?? "NA"}
                                    </p>
                                  </div>
                                )
                              )
                            : (
                                <p className="fontWght600">
                                  {data?.AnnualPenalCharges}
                                </p>
                              ) ?? "NA"}
                        </div>
                      ) : (
                        "NA"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(xii)</td>
                    <td className="parameter-column">
                      {" "}
                      Rate of annualized other penal charges (if any); (details
                      to be provided )
                    </td>
                    <td className="detalis-column">
                      {data?.OtherPenalCharges ? (
                        <div className="other-charges-penal">
                          {data?.OtherPenalCharges &&
                            data?.OtherPenalCharges?.split(" ||").map(
                              (item) => (
                                <div className="d-flex jus-con-spc-btw">
                                  <p className="fontWght600">{item ?? "NA"}</p>
                                </div>
                              )
                            )}
                        </div>
                      ) : (
                        "NA"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no"></td>
                    <td className="parameter-column fontWght600">
                      {" "}
                      Other disclosures
                    </td>
                    <td className="detalis-column"></td>
                  </tr>
                  <tr>
                    <td className="serial-no">(xiii)</td>
                    <td className="parameter-column">
                      Cooling off/look-up period during which borrower shall not
                      be charged any penalty on prepayment of loan
                    </td>
                    <td className="detalis-column">
                      {data?.CoolingPeriod ?? "0 Days"}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(xiv)</td>
                    <td className="parameter-column">
                      Details of LSP acting as recovery agent and authorized to
                      approach the borrower
                    </td>
                    <td className="detalis-column">
                      {data?.RecoveryAgentInfo?.split("||").length === 1 ? (
                        <p className="innerRightPanel">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={data?.RecoveryAgentInfo}
                            className="link-style"
                          >
                            {data?.RecoveryAgentInfo ? "Click Here" : "NA"}
                          </a>
                        </p>
                      ) : data?.RecoveryAgentInfo?.split("||").length > 1 ? (
                        <div className="other-charges-penal">
                          {data?.RecoveryAgentInfo?.split("||").map((item) => (
                            <p className="fontWght600">{item}</p>
                          )) || "NA"}
                        </div>
                      ) : (
                        <p>NA</p>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="serial-no">(xv)</td>
                    <td className="parameter-column">
                      Name, designation, address and phone number of nodal
                      grievance redressal officer designated specifically to
                      deal with FinTech/ digital lending related complaints/
                      issues
                    </td>
                    <td className="detalis-column">
                      {data?.OfficerDetails?.split("||").length === 1 ? (
                        <p className="innerRightPanel">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={data?.OfficerDetails}
                            className="link-style"
                          >
                            {data?.OfficerDetails ? "Click Here" : "NA"}
                          </a>
                        </p>
                      ) : data?.OfficerDetails?.split("||").length > 1 ? (
                        <div className="other-charges-penal">
                          {data?.OfficerDetails?.split("||").map((item) => (
                            <p className="fontWght600">{item}</p>
                          )) || "NA"}
                        </div>
                      ) : (
                        <p>NA</p>
                      )}
                    </td>
                  </tr>
                </table>
                {bankData?.issuer_id?.toString() === "234" ? (
                  <div className="keyfactsPrivacyPolicy">
                    For detailed Privacy Policy of the ICICI bank, please visit{" "}
                    <span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.icicibank.com/privacy.page"
                        className="link-style"
                      >
                        https://www.icicibank.com/privacy.page
                      </a>{" "}
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </>
    </PopUp>
  );
};

export default KeyFactStatementModal;
